import { createContext } from 'react';

import { ExecutionService } from '../data/ExecutionService';

export function createExecutionInstance(compressionEnabled: boolean, compressionMode: string) {
  return new ExecutionService({ compressionEnabled, compressionMode });
}

export const ExecutionContext = createContext<ExecutionService>(createExecutionInstance(true, 'gzip'));

export const ExecutionServiceProvider = ExecutionContext.Provider;
